import { styled } from '@mui/material/styles';
import Card, { CardProps } from '@mui/material/Card';

const TotalsCardStyled = styled(Card, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<CardProps & { isMobile: boolean }>(({ theme, mode, isMobile }) => ({
  borderRadius: 12,
  ...(!isMobile && {
    maxWidth: 300,
  }),
  width: '100%',
  marginLeft: 'auto',
  marginRight: 'auto',
  padding: 12,
  ...(mode === 'dark' && {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  }),
}));

export default TotalsCardStyled;
